export default function ComparisonHandle({ value, onChange }: { value: number; onChange: (value: number) => void }) {
  function updateFromPointer(event: React.PointerEvent<HTMLDivElement>) {
    const bounds = event.currentTarget.parentElement?.getBoundingClientRect();
    if (!bounds || bounds.width <= 0) return;
    onChange(Math.max(0, Math.min(100, ((event.clientX - bounds.left) / bounds.width) * 100)));
  }
  function release(event: React.PointerEvent<HTMLDivElement>) {
    if (event.currentTarget.hasPointerCapture(event.pointerId)) event.currentTarget.releasePointerCapture(event.pointerId);
  }
  return <div
    className="compare-divider"
    role="slider"
    tabIndex={0}
    aria-label="Vorher-Nachher im Bild"
    aria-valuemin={0}
    aria-valuemax={100}
    aria-valuenow={Math.round(value)}
    aria-valuetext={`${Math.round(value)} Prozent Nachher-Bild`}
    style={{ left: `${value}%` }}
    onPointerDown={(event) => { event.preventDefault(); event.currentTarget.setPointerCapture(event.pointerId); updateFromPointer(event); }}
    onPointerMove={(event) => { if (event.currentTarget.hasPointerCapture(event.pointerId)) updateFromPointer(event); }}
    onPointerUp={release}
    onPointerCancel={release}
    onLostPointerCapture={(event) => { if (event.currentTarget.hasPointerCapture(event.pointerId)) event.currentTarget.releasePointerCapture(event.pointerId); }}
    onKeyDown={(event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown'].includes(event.key)) return;
      event.preventDefault();
      onChange(event.key === 'Home' ? 0 : event.key === 'End' ? 100 : Math.max(0, Math.min(100, value + (event.key === 'ArrowLeft' || event.key === 'PageDown' ? -1 : 1))));
    }}
  ><span /></div>;
}
